import {
  BarChart as ReBarChart,
  Bar,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  ReferenceLine,
  LabelList,
} from "recharts";

import { Tooltip } from "./Tooltip";
import { COLORS } from "../../theme/colors";
import { TooltipContent } from "./TooltipContent";
import { nFormatter } from "../../services";

const DEFAULT_BAR_SIZE = 15;

const bottomLabel = (props) => {
  const { x, y, value, name, height, width } = props;

  if (!value) return null;

  return (
    <g>
      <text
        x={x}
        y={y}
        dy={height + 24}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        fontSize={18}
        textAnchor="middle"
      >
        <tspan fill={name === "Unit" ? COLORS.purple : null}>{value ? name : ""}</tspan>
      </text>
    </g>
  );
};

const topLabel = (props) => {
  const { x, y, value, width, height } = props;

  if (!value) return null;

  return (
    <g>
      <text
        x={x}
        y={y}
        dy={0 - height - 40}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        textAnchor="middle"
        style={{ fontSize: 36, fontWeight: 700 }}
      >
        {value}
      </text>
      <text
        x={x}
        y={y}
        dy={0 - height - 20}
        dx={width / 2}
        fill={COLORS.darks[0][100]}
        textAnchor="middle"
        style={{ fontSize: 12 }}
      >
        Paying customers
      </text>
    </g>
  );
};

export const LabelBarChart = ({
  chartData,
  bars,
  height,
  top,
  bottom,
  left,
  right,
  barSize,
  hideXAxis,
  hideYAxis,
  hideCartesianGrid,
  hideReferenceLine,
  hideTooltip,
  hideTopLabel,
  yTickFormatter = nFormatter,
}) => {
  barSize = barSize || DEFAULT_BAR_SIZE;

  return (
    <ResponsiveContainer width="100%" height={height || 200}>
      <ReBarChart
        data={chartData}
        margin={{
          top: top || 20,
          bottom: bottom || 5,
          left: left || 0,
          right: right || 0,
        }}
        barSize={barSize}
      >
        {!hideReferenceLine && <ReferenceLine y={0} stroke={COLORS.darks[0][3]} strokeWidth={2} />}
        {!hideCartesianGrid && <CartesianGrid vertical={false} strokeDasharray="5 2" />}
        {!hideXAxis && <XAxis tickLine={false} dataKey="x" interval="preserveStartEnd" />}
        {!hideYAxis && (
          // IMPORTANT: do not change to `ticketFormatter={yTickFormatter}`
          <YAxis axisLine={false} tickLine={false} tickFormatter={(v) => yTickFormatter(v)} />
        )}
        {!hideTooltip && <Tooltip chartData={chartData} content={<TooltipContent />} />}
        {bars.map((bar, index) => (
          <Bar key={index} dataKey={bar.key} stackId="a" fill={bar.color}>
            {index === 0 && <LabelList dataKey="label" content={(props) => bottomLabel(props)} />}
            {index === chartData.length - 1 && !hideTopLabel && (
              <LabelList dataKey="label" content={(props) => topLabel(props)} />
            )}
          </Bar>
        ))}
      </ReBarChart>
    </ResponsiveContainer>
  );
};
